// @flow

import React, { forwardRef } from "react";
import { SchemaForm } from "@components";
import uiSchema from "./ui-schema";
import type { AbsenceReason } from "@modules/service/reducer/absence-reasons/types";

type OwnProps = $Exact<{
  data: AbsenceReason | Object,
  schema: Object | null,
  onSubmit: (data: AbsenceReason) => void,
}>;

type Props = OwnProps;
const AbsenceReasonsForm = forwardRef(function AbsenceReasonsForm(props, formRef) {
  return (
    <SchemaForm
      ref={formRef}
      className="w-100"
      formData={props.data || {}}
      schema={props.schema || {}}
      uiSchema={uiSchema}
      onSubmit={props.onSubmit}
      externalSubmit
    />
  );
});

export default AbsenceReasonsForm;
